import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import fetchMarketResearchThunk from './services/fetchMarketResearchThunk';
import updateMarketResearchCitiesThunk from './services/updateMarketResearchCitiesThunk';
import { fetchUserMarketResearchThunk } from '../users/services/usersThunks';

const initialState: PieceworkState = {
  marketResearch: {
    apiStatus: APIStatus.IDLE,
    result: {
      idIri: null,
      totalAds: 0,
      totalNewAds: 0,
      cities: null,
    },
    error: undefined,
  },
};

const pieceworkSlice = createSlice({
  name: 'piecework',
  initialState,
  reducers: {
    reset: () => initialState,

    setTotalAds: (
      state,
      action: PayloadAction<Omit<MarketResearch, 'idIri' | 'cities'>>,
    ) => {
      state.marketResearch.result.totalAds = action.payload.totalAds;
      state.marketResearch.result.totalNewAds = action.payload.totalNewAds;
    },
    setNewTotalAds: (state, action: PayloadAction<number>) => {
      state.marketResearch.result.totalNewAds = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMarketResearchThunk.pending, (state) => {
        state.marketResearch.apiStatus = APIStatus.PENDING;
        state.marketResearch.error = undefined;
      })
      .addCase(
        fetchMarketResearchThunk.fulfilled,
        (state, action: PayloadAction<MarketResearch>) => {
          state.marketResearch.apiStatus = APIStatus.IDLE;
          state.marketResearch.error = undefined;
          state.marketResearch.result.cities = action.payload.cities;
        },
      )
      .addCase(fetchMarketResearchThunk.rejected, (state, action) => {
        state.marketResearch.apiStatus = APIStatus.PENDING;
        state.marketResearch.error = action.error;
      });
    builder
      .addCase(updateMarketResearchCitiesThunk.pending, (state) => {
        state.marketResearch.apiStatus = APIStatus.PENDING;
        state.marketResearch.error = undefined;
      })
      .addCase(
        updateMarketResearchCitiesThunk.fulfilled,
        (state, action: PayloadAction<Cities>) => {
          state.marketResearch.apiStatus = APIStatus.IDLE;
          state.marketResearch.error = undefined;
          state.marketResearch.result.cities = action.payload;
        },
      )
      .addCase(updateMarketResearchCitiesThunk.rejected, (state, action) => {
        state.marketResearch.apiStatus = APIStatus.PENDING;
        state.marketResearch.error = action.error;
      });
    builder
      .addCase(fetchUserMarketResearchThunk.pending, (state) => {
        state.marketResearch.apiStatus = APIStatus.PENDING;
        state.marketResearch.error = undefined;
      })
      .addCase(
        fetchUserMarketResearchThunk.fulfilled,
        (state, action: PayloadAction<MarketResearch>) => {
          state.marketResearch.apiStatus = APIStatus.IDLE;
          state.marketResearch.error = undefined;
          state.marketResearch.result = action.payload;
        },
      )
      .addCase(fetchUserMarketResearchThunk.rejected, (state, action) => {
        state.marketResearch.apiStatus = APIStatus.REJECTED;
        state.marketResearch.error = action.error;
      });
  },
});

export default pieceworkSlice.reducer;
export const pieceworkActions = pieceworkSlice.actions;
export const getPieceworkState = (state: RootState) => state.piecework;
